import React from 'react';
import Card from './Card';
import Chart from './Chart';
import DataTable from './DataTable';
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Dashboard Overview</h1>
    </div>
  );
};

export default Dashboard;